import { DateTime } from 'luxon';
/* eslint-disable max-classes-per-file */

import { DATE_HELPER_ISO_DATE_FORMAT } from "../shared/date-helper";

export abstract class JsonSerializable {
    public abstract toJson(): string | undefined;
}

export class DateWithoutTime extends JsonSerializable {
    public date: DateTime | undefined;

    constructor(date: DateTime) {
        super();
        this.date = date;
    }

    public toJson(): string | undefined {
        if (this.date === undefined) {
            return undefined;
        }
        return this.date.toFormat(DATE_HELPER_ISO_DATE_FORMAT);
    }
}

export interface EnumNameAndValue {
    name: string;
    value: number;
}

export class EnumValues {
    public static getNamesAndValues(e: Record<string, number | string>): EnumNameAndValue[] {
        return this.getNames(e).map(enumName => ({ name: enumName, value: e[enumName] as number }));
    }

    public static getNames(e: Record<string, number | string>): string[] {
        return this.getObjectValues(e).filter(v => typeof v === 'string') as string[];
    }

    public static getValues(e: Record<string, number | string>): number[] {
        return this.getObjectValues(e).filter(v => typeof v === 'number') as number[];
    }

    private static getObjectValues(e: Record<string, number | string>): Array<number | string> {
        return Object.keys(e).map(k => e[k]);
    }
}

export interface SoftDeletable {
    isDeleted: boolean;
}

/* export class LogUtils {
    public static toString(value: MultiLingualString): string {
        return value === undefined ? 'undefined' : (value === null ? 'null' : 'de: ' + value.german
            + '; fr: ' + value.french + '; it: ' + value.italian + '; en: ' + value.english);
    }
} */
